import { render, staticRenderFns } from "./DashboardOwner.vue?vue&type=template&id=c8405c22&scoped=true&"
import script from "./DashboardOwner.vue?vue&type=script&lang=js&"
export * from "./DashboardOwner.vue?vue&type=script&lang=js&"
import style0 from "./DashboardOwner.vue?vue&type=style&index=0&id=c8405c22&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8405c22",
  null
  
)

export default component.exports